import { z } from "zod";

export const shareFormSchema = z.object({
  units: z.coerce.number().positive("Units must be greater than 0"),
  price_per_unit: z.coerce.number().positive("Price per unit must be greater than 0"),
  purchase_date: z.string().min(1, "Purchase date is required").refine(
    (val) => !isNaN(Date.parse(val)),
    "Invalid date"
  ),
  note: z.string().optional(),
  // Create-only fields (not required when editing)
  source_account_id: z.string().optional(),
  fee: z.coerce.number().min(0, "Fee cannot be negative").optional(),
  share_currency: z.string().optional(),
});

export type ShareFormValues = z.infer<typeof shareFormSchema>;

/**
 * Creates a share form schema that enforces source_account_id and share_currency
 * on create (isEdit = false).
 */
export function createShareFormSchema(isEdit: boolean) {
  if (isEdit) return shareFormSchema;
  return shareFormSchema.superRefine((data, ctx) => {
    if (!data.source_account_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["source_account_id"],
        message: "Source account is required",
      });
    }
    if (!data.share_currency) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["share_currency"],
        message: "Currency is required",
      });
    }
  });
}
